export let SignupMode;
(function (SignupMode) {
  SignupMode["Embedded"] = "embedded";
  SignupMode["Standalone"] = "standalone";
  SignupMode["Popup"] = "popup";
})(SignupMode || (SignupMode = {}));